import {createRouter, createWebHistory} from 'vue-router';
import OddsmatcherView from "@/views/OddsmatcherView.vue";
import MatchedBettingCalcView from "@/views/matched_bet_calc/MatchedBettingCalcView.vue";
import MbCalcEwView from "@/views/matched_bet_calc/MbCalcEwView.vue";
import OddsConverterView from "@/views/OddsConverterView.vue";
import SingleCalcView from "@/views/bet_calculators/SingleCalcView.vue";
import DoubleCalcView from "@/views/bet_calculators/DoubleCalcView.vue";
import EachWayCalcView from "@/views/bet_calculators/EachWayCalcView.vue";
import AccaCalcView from "@/views/bet_calculators/AccaCalcView.vue";
import TrebleCalcView from "@/views/bet_calculators/TrebleCalcView.vue";
import BogmatcherView from "@/views/BogmatcherView.vue";
import MbCalcExtraPlaceView from "@/views/matched_bet_calc/MbCalcExtraPlaceView.vue";
import EwMatcherView from "@/views/EwMatcherView.vue";
import ExtraPlaceMatcherView from "@/views/ExtraPlaceMatcherView.vue";

const routes = [
    {
        path: '/tools/oddsmatcher/',
        name: 'oddsmatcher',
        component: OddsmatcherView,
    },
    {
        path: '/tools/bogmatcher/',
        name: 'bogmatcher',
        component: BogmatcherView,
    },
    {
        path: '/tools/each-way-matcher/',
        name: 'ew-matcher',
        component: EwMatcherView,
    },
    {
        path: '/tools/extra-place-matcher/',
        name: 'ep-matcher',
        component: ExtraPlaceMatcherView,
    },

    {
        path: '/tools/matched-betting-calculator/normal/',
        name: 'matched-betting-calc',
        component: MatchedBettingCalcView,
    },
    {
        path: '/tools/matched-betting-calculator/each-way/',
        name: 'mb-calc-ew',
        component: MbCalcEwView,
    },
    {
        path: '/tools/matched-betting-calculator/extra-place/',
        name: 'mb-calc-extra-place',
        component: MbCalcExtraPlaceView,
    },
    {
        path: '/tools/odds-converter/',
        name: 'odds-converter',
        component: OddsConverterView,
    },
    {
        path: '/tools/bet-calculator/single/',
        name: 'single',
        component: SingleCalcView,
    },
    {
        path: '/tools/bet-calculator/double/',
        name: 'double',
        component: DoubleCalcView,
    },
    {
        path: '/tools/bet-calculator/treble/',
        name: 'treble',
        component: TrebleCalcView,
    },
    {
        path: '/tools/bet-calculator/acca/',
        name: 'acca',
        component: AccaCalcView,
    },
    {
        path: '/tools/bet-calculator/each-way/',
        name: 'each-way',
        component: EachWayCalcView,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const routeNames = routes.map(route => route.name);

router.beforeEach((to, from, next) => {
    const headingElement = document.getElementById('tools-heading');
    const toolDescriptionElements = document.querySelectorAll('.tool-description-container');

    // Update heading text based on route name
    if (headingElement) {
        if (to.name === 'oddsmatcher') {
            headingElement.textContent = 'Oddsmatcher';
        } else if (to.name === 'matched-betting-calc') {
            headingElement.textContent = 'Matched Betting Calculator';
        } else if (to.name === 'odds-converter') {
            headingElement.textContent = 'Odds Converter';
        } else if (to.name === 'single') {
            headingElement.textContent = 'Single Bet Calculator';
        }
    }

    // Hide elements if navigating from any of the defined routes
    if (routeNames.includes(from.name)) {
        toolDescriptionElements.forEach(element => {
            element.style.display = 'none';
        });
    }

    next();
});

export default router;
